import { useEffect, useRef } from 'react';
export const BLOCKING_TIME = 33.3;
export function useResizeObserver(ref, callback) {
  let lastSuccessEventCall = 0;
  const observer = useRef(typeof window !== 'undefined' ? new ResizeObserver(entries => {
    window.requestAnimationFrame(() => {
      if (!Array.isArray(entries) || entries.length === 0) {
        return;
      }
      const currentTime = Date.now();
      const blockTime = lastSuccessEventCall + BLOCKING_TIME;

      // buffer call for 33.3ms
      if (blockTime > currentTime) {
        return;
      }
      lastSuccessEventCall = currentTime;
      callback(entries[0].contentRect);
    });
  }) : null);
  useEffect(() => {
    const currentRef = ref.current;
    const currentObserver = observer?.current;
    if (currentRef && currentObserver) {
      currentObserver.observe(currentRef);
      callback(currentRef.getBoundingClientRect());
    }
    return () => {
      currentObserver?.unobserve(currentRef);
    };
  }, [ref, observer, callback]);
}